export default __webpack_public_path__ + "static/media/Babbleboticon.0deb51f9.JPG";